import { scales } from './scales.js';

/**
 * Collection of design tokens that define consistent margins and paddings, ensuring harmonious
 * spacing throughout the interface.
 */ const spacings = {
    none: 0,
    '2xs': scales.base * 1,
    xs: scales.base * 2,
    sm: scales.base * 3,
    md: scales.base * 4,
    lg: scales.base * 5,
    xl: scales.base * 6,
    '2xl': scales.base * 8,
    '3xl': scales.base * 12,
    '4xl': scales.base * 16
};

export { spacings };
//# sourceMappingURL=spacings.js.map
